// extracted by mini-css-extract-plugin
export default {"haveClaim":"styles_haveClaim__4l9pf","haveClaimInner":"styles_haveClaimInner__2faZV"};